document.addEventListener("DOMContentLoaded", () => {
  // 1. Fluid Responsive Scaler (Desktop & Tablet >= 768px: 1440px basis, Mobile < 768px: 390px basis)
  let _lastWidth = window.innerWidth;
  const updateLayout = () => {
    const width = window.innerWidth;
    const scaler = document.getElementById('SiteScaler');
    if (!scaler) return;
    if (width === _lastWidth && scaler.style.zoom) return;
    _lastWidth = width;
    if (width >= 768) {
      scaler.style.zoom = (width / 1440);
    } else {
      scaler.style.zoom = (width / 390);
    }
  };
  updateLayout();
  window.addEventListener('resize', () => {
    updateLayout();
    if (typeof ScrollTrigger !== "undefined") ScrollTrigger.refresh();
  });

  // Floating Navbar Controller (Desktop & Mobile)
  const navDesktop = document.getElementById('heroNav');
  const navMobile = document.getElementById('heroNavMobile');
  let lastScrollY = window.scrollY || window.pageYOffset || 0;
  let tickingNav = false;
  const scrollThreshold = 60;
  const deltaThreshold = 4;

  function updateNavbars() {
    const currentScrollY = window.scrollY || window.pageYOffset || 0;
    const isAtTop = currentScrollY <= 20;

    [navDesktop, navMobile].forEach((nav) => {
      if (!nav) return;
      if (isAtTop) {
        nav.classList.remove('nav-floating');
        nav.classList.add('nav-at-top');
      } else {
        nav.classList.remove('nav-at-top');
        nav.classList.add('nav-floating');
      }
    });

    tickingNav = false;
  }

  // Mobile initial spring entrance (< 768px)
  if (navMobile && window.innerWidth < 768) {
    navMobile.style.transform = "translate3d(-50%, -70px, 0) scale(0.9)";
    navMobile.style.opacity = "0";
    setTimeout(() => {
      navMobile.style.transition = "transform 1.1s cubic-bezier(0.34, 1.56, 0.64, 1), opacity 0.7s ease";
      navMobile.style.transform = "translate3d(-50%, 0, 0) scale(1)";
      navMobile.style.opacity = "1";
    }, 150);
  }
  // Tablet & Desktop initial reveal (>= 768px)
  if (navDesktop && window.innerWidth >= 768) {
    navDesktop.classList.remove('nav-initial-hidden');
  }

  // Anti-fragile safety watchdog: ensure hero elements and navbar are always revealed on dynamic load
  setTimeout(() => {
    ['heroHeading', 'heroTagline', 'heroBtn', 'heroBanner', 'heroBg'].forEach((id) => {
      const el = document.getElementById(id);
      if (el) {
        el.classList.remove('opacity-0');
        if (!el.style.opacity || el.style.opacity === '0') {
          el.style.opacity = '1';
        }
      }
    });
    if (navDesktop) {
      navDesktop.classList.remove('nav-initial-hidden');
      if (!navDesktop.style.opacity || navDesktop.style.opacity === '0') {
        navDesktop.style.opacity = '1';
      }
    }
  }, 800);

  window.addEventListener('scroll', () => {
    if (!tickingNav) {
      window.requestAnimationFrame(updateNavbars);
      tickingNav = true;
    }
  }, { passive: true });

  updateNavbars();

  // Mobile Dropdown Navigation & Accordion Controller
  // (Main toggle handlers are defined inline in navbar.liquid for instant responsiveness)
  // Close on outside click if clicked anywhere outside #heroNavMobile
  document.addEventListener('click', (e) => {
    if (navMobile && navMobile.classList.contains('nav-menu-open') && !navMobile.contains(e.target) && !e.target.closest('#mobileNavToggle')) {
      if (typeof window.toggleMobileNav === 'function') {
        window.toggleMobileNav();
      } else {
        navMobile.classList.remove('nav-menu-open', 'shop-active');
        navMobile.querySelectorAll('.mobile-shop-box').forEach(box => box.classList.remove('is-active'));
        const backdrop = document.getElementById('mobileNavBackdrop');
        if (backdrop) backdrop.classList.remove('is-open');
        document.body.classList.remove('mobile-nav-locked');
        document.documentElement.classList.remove('mobile-nav-locked');
      }
    }
  });

  if (typeof gsap === "undefined") return;

  // Desktop & Tablet (>= 768px): runs 1440px canvas animations
  // Mobile (< 768px) is a 1:1 reproduction of HomepageMobile.jsx
  if (window.innerWidth < 768) {
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  const isShopifyEditor = window.Shopify && window.Shopify.designMode;

  // 2. Lenis Smooth Scrolling (respects prefers-reduced-motion for accessibility)
  const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let lenis;
  if (!isShopifyEditor && !prefersReducedMotion && typeof Lenis !== "undefined") {
    lenis = new Lenis({
      duration: 1.5,
      lerp: 0.1,
      smoothWheel: true,
      smoothTouch: false,
      prevent: (node) => {
        return (
          node.closest('#smile-ui-container') ||
          node.closest('[id^="smile-"]') ||
          node.closest('.smile-launcher-frame') ||
          node.closest('.smile-panel-frame') ||
          node.closest('#stamped-reviews-widget') ||
          node.closest('.stamped-side-drawer') ||
          node.closest('#stamped-side-drawer') ||
          node.closest('.cart-drawer') ||
          node.closest('#CartDrawer') ||
          node.closest('#NavDrawer') ||
          (node.hasAttribute && node.hasAttribute('data-lenis-prevent'))
        );
      }
    });
    window.lenis = lenis;

    lenis.on('scroll', () => {
      ScrollTrigger.update();
      if (!tickingNav) {
        window.requestAnimationFrame(updateNavbars);
        tickingNav = true;
      }
    });
    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });
    gsap.ticker.lagSmoothing(0);
  }

  // 3. Awwwards SplitText Roll-Up (Safely splits only text without touching icons/breaks)
  function initSplitTexts() {
    if (isShopifyEditor) return;
    document.querySelectorAll('.split-text').forEach((el) => {
      if (el.dataset.splitDone) return;
      el.dataset.splitDone = "true";

      const text = el.textContent.trim();
      const words = text.split(/\s+/).filter(Boolean);
      if (!words.length) return;

      el.innerHTML = words.map((w, idx) => {
        const mr = idx === words.length - 1 ? '' : 'mr-[0.25em]';
        return `<span class="inline-block overflow-hidden ${mr} align-bottom pb-1"><span class="split-word inline-block origin-bottom-left" style="transform: translateY(140%) rotate(10deg); opacity: 0;">${w}</span></span>`;
      }).join('');

      // Fallback ScrollTrigger for standalone split-text not managed by a section timeline
      if (!el.closest('#MakingWellnessSection, #IngredientsInfoSection, #CommunityStoriesSection, #CTASection, #HeroOptionSection')) {
        const wordEls = el.querySelectorAll('.split-word');
        const trigger = el.closest('h1, h2, section') || el;

        gsap.to(wordEls, {
          y: "0%",
          rotateZ: 0,
          opacity: 1,
          duration: 1.4,
          stagger: 0.045,
          ease: "power4.out",
          scrollTrigger: {
            trigger: trigger,
            start: "top 92%",
            once: true
          }
        });
      }
    });
  }
  initSplitTexts();

  // 4. Hero Section Animations
  const hero = document.getElementById('HeroOptionSection');
  if (hero) {
    const bg = document.getElementById('heroBg');
    const banner = document.getElementById('heroBanner');
    const nav = document.getElementById('heroNav');
    const tagline = document.getElementById('heroTagline');
    const heading = document.getElementById('heroHeading');
    const btn = document.getElementById('heroBtn');

    if (isShopifyEditor) {
      if (nav) {
        nav.classList.remove('nav-initial-hidden');
        gsap.set(nav, { opacity: 1, y: 0, xPercent: -50, scale: 1, clearProps: "all" });
      }
      [bg, banner, tagline, heading, btn].forEach((el) => {
        if (el) {
          el.classList.remove('opacity-0');
          gsap.set(el, { opacity: 1, y: 0, clearProps: "all" });
        }
      });
    } else {
      if (bg) {
        gsap.fromTo(bg,
          { scale: 2.2, filter: "blur(25px)", opacity: 0 },
          { scale: 1, filter: "blur(0px)", opacity: 1, duration: 1.8, ease: "power4.inOut" }
        );
      }
      if (banner) {
        gsap.fromTo(banner,
          { y: "-100%" },
          { y: "0%", duration: 1.2, delay: 0.4, ease: "power4.inOut", onComplete: () => gsap.set(banner, { clearProps: "transform" }) }
        );
      }
      if (nav) {
        nav.classList.remove('nav-initial-hidden');
        gsap.fromTo(nav,
          { y: -70, xPercent: -50, opacity: 0, scale: 0.9 },
          {
            y: 0,
            xPercent: -50,
            opacity: 1,
            scale: 1,
            duration: 1.3,
            delay: 0.5,
            ease: "back.out(1.7)",
            onComplete: () => gsap.set(nav, { clearProps: "transform,opacity,scale" })
          }
        );
      }
      if (tagline) {
        gsap.fromTo(tagline,
          { y: 30, opacity: 0 },
          { y: 0, opacity: 1, duration: 1.2, delay: 0.8, ease: "power4.inOut" }
        );
      }
      if (heading) {
        gsap.fromTo(heading,
          { y: 50, opacity: 0 },
          { y: 0, opacity: 1, duration: 1.4, delay: 0.7, ease: "power4.out" }
        );
      }
      if (btn) {
        gsap.fromTo(btn,
          { y: 35, opacity: 0, scale: 0.85 },
          { y: 0, opacity: 1, scale: 1, duration: 1.2, delay: 1.0, ease: "back.out(1.7)" }
        );
      }
    }

    // Scrub parallax on scroll
    ScrollTrigger.create({
      trigger: hero,
      start: "top top",
      end: "bottom top",
      scrub: true,
      onUpdate: (self) => {
        const p = self.progress;
        if (bg) gsap.set(bg, { scale: 1 + p * 0.4, y: `${p * 20}%` });
        if (heading) gsap.set(heading, { y: `${p * -60}%`, opacity: 1 - p * 2 });
        if (tagline) gsap.set(tagline, { y: `${p * -80}%`, opacity: 1 - p * 2 });
        if (btn) gsap.set(btn, { y: `${p * -40}%`, opacity: 1 - p * 2 });
      }
    });
  }

  // 5. Making Wellness (Hierarchy: Card Background visible -> Image -> Title -> Description -> Button & Footnote)
  const wellnessSection = document.getElementById('MakingWellnessSection');
  if (wellnessSection) {
    const card = document.getElementById('wellnessCard');
    const img = document.getElementById('wellnessImg');
    const headingWords = wellnessSection.querySelectorAll('h2 .split-word');
    const icon = document.getElementById('wellnessIcon');
    const body = document.getElementById('wellnessBody');
    const btnGroup = document.getElementById('wellnessBtnGroup');

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: card || wellnessSection,
        start: "top 83%",
        once: true
      }
    });

    // Note: Section background (#MakingWellnessSection) & card (#wellnessCard) remain visible

    // 0. Product Image Entrance
    if (img) {
      tl.fromTo(img,
        { y: 50, opacity: 0, scale: 1.06 },
        { y: 0, opacity: 1, scale: 1, duration: 1.1, ease: "power3.out" },
        0
      );
    }

    // 1. HIERARCHY 1: Title Roll-Up + Watermelon Icon Pop
    if (headingWords.length) {
      tl.to(headingWords, {
        y: "0%",
        rotateZ: 0,
        opacity: 1,
        duration: 1.1,
        stagger: 0.045,
        ease: "power4.out"
      }, 0.15);
    }
    if (icon) {
      tl.fromTo(icon,
        { scale: 0, rotateZ: -60 },
        { scale: 1, rotateZ: 0, duration: 0.8, ease: "back.out(2)" },
        0.55
      );
    }

    // 2. HIERARCHY 2: Description Entrance
    if (body) {
      tl.fromTo(body,
        { y: 35, opacity: 0 },
        { y: 0, opacity: 1, duration: 1.1, ease: "power3.out" },
        0.65
      );
    }

    // 3. HIERARCHY 3: Button & Footnote Entrance
    if (btnGroup) {
      tl.fromTo(btnGroup,
        { y: 30, opacity: 0, scale: 0.95 },
        { y: 0, opacity: 1, scale: 1, duration: 1.05, ease: "back.out(1.5)" },
        0.95
      );
    }
  }

  // 6. Explore Collection (Horizontal Marquee Scroll + True Locomotive Parallax)
  const explore = document.getElementById('ExploreCollectionSection');
  if (explore) {
    const marquee = document.getElementById('exploreMarquee');
    const icon = document.getElementById('exploreIcon');
    const col1 = explore.querySelectorAll('.col-loco-1');
    const col2 = explore.querySelectorAll('.col-loco-2');
    const col3 = explore.querySelectorAll('.col-loco-3');
    const col4 = explore.querySelectorAll('.col-loco-4');

    const cardsGrid = document.getElementById('exploreCardsGrid') || explore.querySelector('.grid');

    // Marquee: continuous scrub across the entire section
    if (marquee) {
      gsap.to(marquee, {
        xPercent: -70,
        ease: "none",
        scrollTrigger: {
          trigger: explore,
          start: "top bottom",
          end: "bottom top",
          scrub: 1.2
        }
      });
    }

    // 4 Columns Locomotive Parallax:
    if (cardsGrid && (col1.length || col2.length || col3.length || col4.length)) {
      const updateParallax = (self) => {
        const p = self.progress; // 0 (start) to 1 (end)
        const factor = Math.max(0, 1 - p); // 1.0 -> 0.0

        // ponytail: moderate travel offsets staying inside/near own section
        const y1 = 140 * factor;
        const y2 = -95 * factor;
        const y3 = 90 * factor;
        const y4 = -130 * factor;

        // Opacity: starts very faded (0) to fully visible (1) near the end
        const opacity = Math.min(1, Math.max(0, (p - 0.05) / 0.75));

        col1.forEach(el => gsap.set(el, { y: y1, opacity: opacity }));
        col2.forEach(el => gsap.set(el, { y: y2, opacity: opacity }));
        col3.forEach(el => gsap.set(el, { y: y3, opacity: opacity }));
        col4.forEach(el => gsap.set(el, { y: y4, opacity: opacity }));
      };

      ScrollTrigger.create({
        trigger: cardsGrid,
        start: "top bottom",
        end: "center 55%",
        scrub: 1.2,
        onUpdate: updateParallax,
        onRefresh: updateParallax
      });
    }

    // Pineapple icon pop-in
    if (icon) {
      gsap.fromTo(icon,
        { scale: 0, rotateZ: 90, opacity: 0 },
        {
          scale: 1,
          rotateZ: 0,
          opacity: 1,
          duration: 1.5,
          delay: 0.4,
          ease: "back.out(1.7)",
          scrollTrigger: {
            trigger: icon.closest('h1') || icon,
            start: "top 88%",
            once: true
          }
        }
      );
    }
  }

  // 7. Ingredients Info (Split ScrollTrigger: Header & Sachet/Badges)
  const ingredients = document.getElementById('IngredientsInfoSection');
  if (ingredients) {
    const headingWords = ingredients.querySelectorAll('h2 .split-word');
    const icon = document.getElementById('ingredientsIcon');
    const subtitle = document.getElementById('ingredientsSubtitle');
    const sachet = ingredients.querySelector("img[alt='Electrolytes Sachet']");
    const arrow1 = ingredients.querySelector('.arrow-1');
    const label1 = ingredients.querySelector('.label-1');
    const arrow2 = ingredients.querySelector('.arrow-2');
    const label2 = ingredients.querySelector('.label-2');
    const arrow3 = ingredients.querySelector('.arrow-3');
    const label3 = ingredients.querySelector('.label-3');

    // Part 1: Header (Title & Subtitle)
    const headerTl = gsap.timeline({
      scrollTrigger: {
        trigger: ingredients.querySelector('h2') || ingredients,
        start: "top 85%",
        once: true
      }
    });

    if (headingWords.length) {
      headerTl.to(headingWords, {
        y: "0%",
        rotateZ: 0,
        opacity: 1,
        duration: 1.1,
        stagger: 0.045,
        ease: "power4.out"
      }, 0);
    }
    if (icon) {
      headerTl.fromTo(icon,
        { scale: 0, rotateZ: -90 },
        { scale: 1, rotateZ: 0, duration: 0.8, ease: "back.out(2)" },
        0.35
      );
    }
    if (subtitle) {
      headerTl.fromTo(subtitle,
        { y: 30, opacity: 0 },
        { y: 0, opacity: 1, duration: 1.05, ease: "power3.out" },
        0.45
      );
    }

    // Part 2: Sachet & Decorative Arrows/Labels
    const sachetTrigger = sachet || arrow1 || ingredients;
    const sachetTl = gsap.timeline({
      scrollTrigger: {
        trigger: sachetTrigger,
        start: "top 85%",
        once: true
      }
    });

    if (sachet) {
      sachetTl.fromTo(sachet,
        { y: 80, opacity: 0 },
        { y: 0, opacity: 1, duration: 1.2, ease: "power3.out" },
        0
      );
    }

    if (arrow1) {
      sachetTl.fromTo(arrow1,
        { scaleX: 0, opacity: 0 },
        { scaleX: 1, opacity: 1, duration: 0.8, ease: "power3.out" },
        0.30
      );
    }
    if (label1) {
      sachetTl.fromTo(label1,
        { x: -30, opacity: 0 },
        { x: 0, opacity: 1, duration: 0.8, ease: "power3.out" },
        0.35
      );
    }

    if (arrow2) {
      sachetTl.fromTo(arrow2,
        { scaleX: 0, opacity: 0 },
        { scaleX: 1, opacity: 1, duration: 0.8, ease: "power3.out" },
        0.55
      );
    }
    if (label2) {
      sachetTl.fromTo(label2,
        { y: 30, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.8, ease: "power3.out" },
        0.60
      );
    }

    if (arrow3) {
      sachetTl.fromTo(arrow3,
        { scaleX: 0, opacity: 0 },
        { scaleX: 1, opacity: 1, duration: 0.8, ease: "power3.out" },
        0.80
      );
    }
    if (label3) {
      sachetTl.fromTo(label3,
        { x: 30, opacity: 0 },
        { x: 0, opacity: 1, duration: 0.8, ease: "power3.out" },
        0.85
      );
    }
  }

  // 8. Community Stories (Hierarchy: Title > Description > Navigation Arrows > Cards Stagger In)
  const stories = document.getElementById('CommunityStoriesSection');
  if (stories) {
    const headingWords = stories.querySelectorAll('h2 .split-word');
    const icon = document.getElementById('storiesIcon');
    const subtitle = document.getElementById('storiesSubtitle');
    const prevBtn = document.getElementById('desktopStoriesPrevBtn');
    const nextBtn = document.getElementById('desktopStoriesNextBtn');
    const items = stories.querySelectorAll('.story-item');

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: stories,
        start: "top 83%",
        once: true
      }
    });

    // 1. HIERARCHY 1: Title
    if (headingWords.length) {
      tl.to(headingWords, {
        y: "0%",
        rotateZ: 0,
        opacity: 1,
        duration: 1.1,
        stagger: 0.045,
        ease: "power4.out"
      }, 0.1);
    }
    if (icon) {
      tl.fromTo(icon,
        { scale: 0, rotateZ: 90 },
        { scale: 1, rotateZ: 0, duration: 0.8, ease: "back.out(2)" },
        0.40
      );
    }

    // 2. HIERARCHY 2: Description (Subtitle)
    if (subtitle) {
      tl.fromTo(subtitle,
        { y: 30, opacity: 0 },
        { y: 0, opacity: 1, duration: 1.05, ease: "power3.out" },
        0.50
      );
    }

    // 3. HIERARCHY 3: Navigation Arrows
    if (prevBtn && nextBtn) {
      tl.fromTo([prevBtn, nextBtn],
        { scale: 0.7, opacity: 0 },
        { scale: 1, opacity: 1, duration: 0.9, ease: "back.out(2)" },
        0.75
      );
    }

    // 4. HIERARCHY 4: Cards Carousel Stagger In
    if (items.length) {
      tl.fromTo(items,
        { y: 65, opacity: 0 },
        { y: 0, opacity: 1, duration: 1.2, stagger: 0.12, ease: "power4.out" },
        0.85
      );
    }
  }

  // 9. CTA Section (Hierarchy: Title -> Description -> Form/Button)
  const cta = document.getElementById('CTASection');
  if (cta) {
    const wrapper = document.getElementById('ctaWrapper');
    const bgZoom = document.getElementById('ctaBgZoom');
    const leftHead = document.getElementById('ctaLeftHead');
    const leftBody = document.getElementById('ctaLeftBody');
    const leftBtn = document.getElementById('ctaLeftBtn');
    const rightHeadWords = cta.querySelectorAll('.flex-1 h2 .split-word');
    const rightIcon = document.getElementById('ctaRightIcon');
    const rightBody = document.getElementById('ctaRightBody');
    const ctaInput = document.getElementById('ctaInput');

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: wrapper || cta,
        start: "top 80%",
        once: true
      }
    });

    // Note: Banner background (#ctaWrapper) remains visible

    if (bgZoom) {
      tl.fromTo(bgZoom,
        { scale: 1.15 },
        { scale: 1, duration: 2.1, ease: "power3.out" },
        0
      );
    }

    // 1. HIERARCHY 1: Left & Right Titles
    if (leftHead) {
      tl.fromTo(leftHead,
        { y: 35, opacity: 0 },
        { y: 0, opacity: 1, duration: 1.1, ease: "power3.out" },
        0.10
      );
    }
    if (rightHeadWords.length) {
      tl.to(rightHeadWords, {
        y: "0%",
        rotateZ: 0,
        opacity: 1,
        duration: 1.1,
        stagger: 0.045,
        ease: "power4.out"
      }, 0.10);
    }
    if (rightIcon) {
      tl.fromTo(rightIcon,
        { scale: 0, rotateZ: -180 },
        { scale: 1, rotateZ: 0, duration: 0.8, ease: "back.out(2)" },
        0.45
      );
    }

    // 2. HIERARCHY 2: Left & Right Descriptions
    if (leftBody) {
      tl.fromTo(leftBody,
        { y: 35, opacity: 0 },
        { y: 0, opacity: 1, duration: 1.1, ease: "power3.out" },
        0.65
      );
    }
    if (rightBody) {
      tl.fromTo(rightBody,
        { y: 35, opacity: 0 },
        { y: 0, opacity: 1, duration: 1.1, ease: "power3.out" },
        0.65
      );
    }

    // 3. HIERARCHY 3: Left Button & Right Form Input
    if (leftBtn) {
      tl.fromTo(leftBtn,
        { y: 30, opacity: 0, scale: 0.95 },
        { y: 0, opacity: 1, scale: 1, duration: 1.05, ease: "back.out(1.5)" },
        0.95
      );
    }
    if (ctaInput) {
      tl.fromTo(ctaInput,
        { y: 30, opacity: 0 },
        { y: 0, opacity: 1, duration: 1.05, ease: "power3.out" },
        0.95
      );
    }
  }

  // 10. Footer Section (Hierarchy: Container > Brand & Description > Nav Links > Big Text & Socials)
  const footerSec = document.getElementById('FooterSection');
  if (footerSec) {
    const inners = footerSec.querySelectorAll('#footerInner');
    const bigTexts = footerSec.querySelectorAll('.footer-big-text, #footerBigText');
    const logoCol = footerSec.querySelector('#footerLogoCol');
    const navCols = footerSec.querySelectorAll('#footerInner .flex-1');
    const socials = footerSec.querySelectorAll('#footerSocial .footer-social-btn');

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: footerSec,
        start: "top 92%",
        once: true
      }
    });

    if (inners.length) {
      tl.fromTo(inners,
        { y: 65, scale: 0.95, opacity: 0 },
        { y: 0, scale: 1, opacity: 1, duration: 1.55, ease: "power4.out" },
        0
      );
    }

    // 1. HIERARCHY 1 & 2: Brand Logo & Description
    if (logoCol) {
      tl.fromTo(logoCol,
        { y: 35, opacity: 0 },
        { y: 0, opacity: 1, duration: 1.45, ease: "power4.out" },
        0.30
      );
    }

    // 2. HIERARCHY 3: Navigation Links
    if (navCols.length) {
      tl.fromTo(navCols,
        { y: 35, opacity: 0 },
        { y: 0, opacity: 1, duration: 1.45, stagger: 0.12, ease: "power4.out" },
        0.55
      );
    }

    // 3. Socials
    if (socials.length) {
      tl.fromTo(socials,
        { scale: 0, opacity: 0 },
        { scale: 1, opacity: 1, duration: 0.9, stagger: 0.08, ease: "back.out(2)" },
        0.85
      );
    }

    // 4. Big "me today" watermark
    if (bigTexts.length) {
      tl.fromTo(bigTexts,
        { y: "50%", opacity: 0 },
        { y: "0%", opacity: 1, duration: 1.5, ease: "power4.out" },
        0.35
      );
    }
  }

  // Refresh ScrollTrigger so all positions are calibrated with zoom
  setTimeout(() => {
    ScrollTrigger.refresh();
  }, 200);

  if (isShopifyEditor) {
    const revealAll = () => {
      const nav = document.getElementById('heroNav');
      if (nav) {
        nav.classList.remove('nav-initial-hidden');
        nav.style.opacity = '1';
        nav.style.transform = 'translate3d(-50%, 0, 0) scale(1)';
      }
      ['heroTagline', 'heroHeading', 'heroBtn', 'heroBanner', 'heroBg'].forEach((id) => {
        const el = document.getElementById(id);
        if (el) {
          el.style.opacity = '1';
          el.style.visibility = 'visible';
          el.classList.remove('opacity-0');
        }
      });
      document.querySelectorAll('.split-word, .split-text').forEach((el) => {
        el.style.opacity = '1';
        el.style.transform = 'none';
        el.style.visibility = 'visible';
      });
      ScrollTrigger.refresh();
    };

    ['shopify:section:load', 'shopify:section:reorder', 'shopify:section:select', 'shopify:block:select'].forEach((evt) => {
      document.addEventListener(evt, revealAll);
    });
  }
});
